import React from 'react';
import { BasicItem } from '../../components/FormItem';
import PickerView, { DataSource } from './PickerView';
import Right from './images/right@2x.png';
import styles from './Picker.module.scss';

interface Props {
  label: string | React.ReactNode;
  placeholder?: string;
  data: DataSource[] | Array<DataSource[]>; // 支持多列或单列及内联
  value: Array<string | number>;
  onChange: (value: Array<string | number>) => void;
  className?: string;
  multiple?: boolean; // 是否有多列选择
  cols?: number; // 级联下的层级
  cascade?: boolean; // 是否级联
  formate?: (value: Array<string | number>) => string;
  title?: string;
  notShowValue?: boolean; // 是否不显示已选value
  onScroll?: (valueList: Array<string | number | undefined>) => void; // 列表滚动
  wrapperClassName?: string;
}

export default function Picker(props: Props) {
  const {
    label,
    placeholder = '请选择',
    value,
    formate,
    className,
    ...other
  } = props;
  let _value: any = [];

  if (!value.length && (other.multiple || (other.cascade && other.cols))) {
    _value.length = other.multiple ? other.data.length : other.cols;
    _value.fill(undefined);
  } else {
    _value = value;
  }

  return (
    <BasicItem label={label} className={className}>
      <PickerView {...other} value={_value}>
        <div className={styles.content}>
          <p>
            {!other.notShowValue ? (
              value.length ? (
                formate ? (
                  formate(value)
                ) : (
                  value
                )
              ) : (
                <span>{placeholder}</span>
              )
            ) : (
              <span>{placeholder}</span>
            )}
          </p>
          <img src={Right} />
        </div>
      </PickerView>
    </BasicItem>
  );
}

Picker.defaultProps = {
  title: '',
  notShowValue: false,
  wrapperClassName: '',
};
